import LAPicture from '../img/experience/2.jpg';

const MustHaveLAPicture = {
	id: 2, img: LAPicture, permalink: "must-have-l-a-picture", title: "Must Have L.A. Picture", city: "Photo Class - Los Angeles", location: "Los Angeles, United States", star: 4.98, cost: 3
};
export default MustHaveLAPicture;